module.exports = __webpack_public_path__ + "img/magento-version-switching.c8ca358d.jpg";